import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SiteProvider } from "@/lib/site";
import { CompareProvider, CompareTray } from "@/lib/compare";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import Home from "@/pages/Home";
import { SoftwarePage, CategoriesPage, CategoryPage } from "@/pages/Listings";
import SoftwareDetail from "@/pages/SoftwareDetail";
import { ComparisonsPage, ComparisonDetail, CompareBuilder } from "@/pages/Comparisons";
import { BlogPage, ArticleDetail } from "@/pages/Blog";
import { AboutPage, ContactPage, LegalPage, NotFound } from "@/pages/Static";
import { ClerkLayout, SignInPage, SignUpPage } from "@/pages/AuthPages";
import AdminApp from "@/admin/AdminApp";

function PublicLayout() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return (
    <>
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[60] btn-primary">Skip to content</a>
      <Header />
      <main id="main" className="min-h-[60vh]"><Outlet /></main>
      <Footer />
      <CompareTray />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <SiteProvider>
        <CompareProvider>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/software" element={<SoftwarePage />} />
              <Route path="/software/:slug" element={<SoftwareDetail />} />
              <Route path="/categories" element={<CategoriesPage />} />
              <Route path="/categories/:slug" element={<CategoryPage />} />
              <Route path="/comparisons" element={<ComparisonsPage />} />
              <Route path="/comparisons/:slug" element={<ComparisonDetail />} />
              <Route path="/compare" element={<CompareBuilder />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<ArticleDetail />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/legal/:slug" element={<LegalPage />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route element={<ClerkLayout />}>
              <Route path="/sign-in/*" element={<SignInPage />} />
              <Route path="/sign-up/*" element={<SignUpPage />} />
              <Route path="/admin/*" element={<AdminApp />} />
            </Route>
          </Routes>
          <Toaster position="top-right" richColors />
        </CompareProvider>
      </SiteProvider>
    </BrowserRouter>
  );
}

export default App;
